import React from 'react';
import CustomerFooter from '../LandingPage/CustomerHomePage/CustomerFooter/CustomerFooter';

const FooterContainer = () => {
  return <CustomerFooter />;
};

export default FooterContainer;
